import { ChildProcessWithoutNullStreams } from "child_process";
import { CommApiInstance } from "Utils/CommApiInstance";




const MembQnaCtgrLstApi= async (
    GameSvcCd:string,
) => {
    return await CommApiInstance.post(`comm/${GameSvcCd}/qna/ctgr_lst`,{
        apiBody:{

        },
    })
    .then((Resp) => Resp.data);
}
export default MembQnaCtgrLstApi;